import { createPortal } from 'react-dom';

import type {
  ModalContentProps,
  ModalFooterProps,
  ModalHeaderProps,
  ModalProps
} from './Modal.types';

import { S } from './Modal.styles';

export const Modal = ({
  isOpen = true,
  children,
  borderLess = false,
  onClose,
  tabIndex = 0
}: ModalProps) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget && onClose) {
      onClose();
    }
  };

  return createPortal(
    <S.Backdrop onClick={handleBackdropClick}>
      <S.Wrapper $borderLess={borderLess} tabIndex={tabIndex}>
        {children}
      </S.Wrapper>
    </S.Backdrop>,
    document.body
  );
};

const ModalHeader = ({ children }: ModalHeaderProps) => {
  const childCount = Array.isArray(children) ? children.length : 1;

  const headerJustify = childCount <= 1 ? 'end' : 'space-between';

  return <S.Header $justifyContent={headerJustify}>{children}</S.Header>;
};

const ModalContent = ({ children, bgColor }: ModalContentProps) => {
  return <S.Content $bgColor={bgColor}>{children}</S.Content>;
};

const ModalFooter = ({ children }: ModalFooterProps) => {
  return <S.Footer>{children}</S.Footer>;
};

Modal.Header = ModalHeader;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
